

import algoliasearch from 'algoliasearch'

const algoliaClient = algoliasearch('YAAAUS4GNX', '3f4f7382331db6370f76a327aaf70326')

export default class {


    static getContactIndex(tenantKey) {
        return algoliaClient.initIndex('contacts_' + tenantKey) 
    }

    static saveToIndex(indexName, obj) {
        const index = algoliaClient.initIndex(indexName)
        index.saveObject(obj).then(({ objectID }) => {
            console.log('Saved to Algolia')
        })
    }

    static saveListToIndex(indexName, arr) {
        const index = algoliaClient.initIndex(indexName)
        index.saveObjects(arr).then(({ objectIDs }) => {
            console.log('Saved ' + arr.length + ' items to Algolia')
        })
    }





        
}


// WEBPACK FOOTER //
// ./src/helpers/AlgoliaHelpers.js